export function initModal(observer){

    init();

    function init(){
        if(!$('.search-container').length) {
            $('.modal-message').css('display','none !important');
        }

        if(localStorage.getItem("modalClosed")){
            $('.modal-message').hide();
        }

        $('.modal-message').on('click',function (){
            $(this).hide();
            localStorage.setItem("modalClosed", "true");
        })

    }
    //ресайз изображений
    $('.resize-image').on('click', function() {
        $('.flat-modal').css('display','flex');
        $('.modal-content').prepend(`
            <img class="image small lozad" data-background="${$('.plan-image.lozad.active').data('background')}">
            `);
        observer.observe();

        $('.lozad').contextmenu(function (e){
            e.stopPropagation();
            e.preventDefault();
        })
    });

    $('.close-modal').on('click', function (){
        $('.modal').css('display','none');
        $('.modal-with-arrow').css('display','none');
        $('.flat-modal').css('display','none');
        $('.modal-content').find('.image').remove();
    })

    $('.resize-image-plan').on('click', function() {
        // Находим родительский слайд, соответствующий кнопке
        const $slide = $(this).closest('.swiper-slide');
        // Находим картинку внутри слайда
        const $image = $slide.find('.plan-image.active');
        // Получаем URL картинки
        const imgUrl = $image.attr('src') || $image.attr('data-background');
        // Открываем картинку в новой вкладке
        $('.flat-modal').css('display','flex');
        $('.modal-content').prepend(`
            <img class="image small lozad" data-background="${imgUrl}">
            `);
        observer.observe();
        $('.lozad').contextmenu(function (e){
            e.stopPropagation();
            e.preventDefault();
        })
    });

    if(window.innerWidth > 767){
        $('.main-image.right').on('click', function (){
            $('.modal').css('display','flex');
            $('.modal-content').prepend(`
            <img class="image small lozad" data-background="${$(this).attr('src')}">
            `);
            observer.observe();
            $('.lozad').contextmenu(function (e){
                e.stopPropagation();
                e.preventDefault();
            })
        })

        $('.main-image.left-small').on('click', function (){
            $('.modal').css('display','flex');
            $('.modal-content').prepend(`
        <img class="image small lozad" data-background="${$(this).attr('src')}">
        `);
            observer.observe();
            $('.lozad').contextmenu(function (e){
                e.stopPropagation();
                e.preventDefault();
            })
        })


        const smallImages = document.querySelectorAll('.resize-small-image');
        const modal = document.querySelector('.modal-with-arrow');
        let modalImage = $('.modal-with-arrow .modal-content .image');
        const prevArrow = $('#slide_prev');
        const nextArrow = $('#slide_next');

        smallImages.forEach(image => {
            image.addEventListener('click', () => {
                modal.style.display = 'flex';
                const currentIndex = Array.from(smallImages).findIndex(img => img.src === image.src);
                $('.modal-content').prepend(`
      <img class="image small lozad" data-background="${image.src}" data-index="${currentIndex}">
    `);
                observer.observe();
                modalImage = $('.modal-with-arrow .modal-content .image').eq(0);
                if(currentIndex === 0){
                    prevArrow.addClass('disable')
                } else if (currentIndex === 2){
                    nextArrow.addClass('disable')
                } else {
                    prevArrow.removeClass('disable')
                    nextArrow.removeClass('disable')
                }
                $('.lozad').contextmenu(function (e){
                    e.stopPropagation();
                    e.preventDefault();
                })
            });
        });

        prevArrow.on('click', () => {
            const currentIndex = parseInt(modalImage.attr('data-index'));
            if (currentIndex > 0) {
                const prevIndex = currentIndex - 1;
                const prevImageSrc = smallImages[prevIndex].src;
                $('.modal-content').find('.image').remove();
                $('.modal-content').prepend(`
      <img class="image small lozad" data-background="${prevImageSrc}" data-index="${prevIndex}">
    `);
                observer.observe();
                modalImage = $('.modal-with-arrow .modal-content .image').eq(0);
                if(prevIndex === 0){
                    prevArrow.addClass('disable')
                }
                nextArrow.removeClass('disable')
            }
            $('.lozad').contextmenu(function (e){
                e.stopPropagation();
                e.preventDefault();
            })
        });

        nextArrow.on('click', () => {
            const currentIndex = parseInt(modalImage.attr('data-index'));
            if (currentIndex < smallImages.length - 1) {
                const nextIndex = currentIndex + 1;
                const nextImageSrc = smallImages[nextIndex].src;
                $('.modal-content').find('.image').remove();
                $('.modal-content').prepend(`
      <img class="image small lozad" data-background="${nextImageSrc}" data-index="${nextIndex}">
    `);
                observer.observe();
                modalImage = $('.modal-with-arrow .modal-content .image').eq(0);
                if(nextIndex === 2){
                    nextArrow.addClass('disable')
                }
                prevArrow.removeClass('disable')
            }
            $('.lozad').contextmenu(function (e){
                e.stopPropagation();
                e.preventDefault();
            })
        });
    }

}